import { Transforms } from "slate";
import { Slate } from "@makeswift/controls";
import { getSelection } from "../selectors";
function unwrapInline(editor, type) {
  Transforms.unwrapNodes(editor, {
    match: (node) => Slate.isInline(node) && node.type === type,
    at: getSelection(editor)
  });
}
export {
  unwrapInline
};
//# sourceMappingURL=unwrapInline.js.map